<template>
    <div class="add-model">
        <center><h3>AGREGAR PERFIL ADMINISTRATIVO</h3></center>
        <div class="info">
            <div class="column">
                <center>
                    <label for="">Nombre</label>
                    <input type="text" v-model="$v.nameValue.$model" placeholder="Agregar nombre">
                    <div v-if="$v.nameValue.$error" class="error">El nombre es un campo obligatorio</div>
                    <label for="">Apellido</label>
                    <input type="text" v-model="$v.lastNameValue.$model" placeholder="Agregar apellido">
                    <div v-if="$v.lastNameValue.$error" class="error">El apellido es un campo obligatorio</div>
                    <label for="">Tipo de documento</label>
                    <select name="" id="" v-model="$v.typeDocumentValue.$model">
                        <option value="cc">Cedula de ciudadania</option>
                        <option value="ce">Cedula de extranjeria</option>
                        <option value="pasaport">Pasaporte</option>
                        <option value="other">Otro</option>
                    </select>
                    <div v-if="$v.typeDocumentValue.$error" class="error">El tipo de documento es un campo obligatorio</div>
                    <label for="">Documento</label>
                    <input type="number" v-model="$v.documentValue.$model" placeholder="Agregar documento">
                    <div v-if="$v.documentValue.$error" class="error">El Documento es un campo obligatorio</div>
                    <label for="">Fecha de nacimiento</label>
                    <input type="date" v-model="$v.dayOfBirdthValue.$model">
                    <div v-if="$v.dayOfBirdthValue.$error" class="error">la fecha de nacimiento es un campo obligatorio</div>
                    <label for="">Nacionalidad</label>
                    <select name="" id="" v-model="$v.countryValue.$model">
                        <option v-for="(elem, index) in countries" :key="index" :value="elem">{{ elem }}</option>
                    </select>
                    <div v-if="$v.countryValue.$error" class="error">La Nacionalidad es un campo obligatorio</div>
                </center>
            </div>
            <div class="column">
                <center>
                    <label for="">Turno</label>
                    <select name="" id="" v-model="$v.turnoValue.$model">
                        <option value="mañana">Mañana</option>
                        <option value="tarde">Tarde</option>
                        <option value="noche">Noche</option>
                    </select>
                    <label for="">Sede</label>
                    <select name="" id="" v-model="$v.sedeValue.$model">
                        <option :value="sede" v-for="(sede, index) in sedes" :key="index">{{sede}}</option>
                    </select>
                    <div v-if="$v.turnoValue.$error" class="error">El turno es un campo obligatorio</div>
                    <label for="">Celular</label>
                    <vue-tel-input v-model.lazy="$v.phoneValue.$model" onpaste="return false;"
                        @keypress.native="checkPhoneNumber" :preferredCountries="['co']" v-bind:placeholder="'phone'">
                    </vue-tel-input>
                    <div v-if="$v.phoneValue.$error" class="error">El celular es un campo obligatorio</div>
                    <label for="">Correo electronico</label>
                    <input type="email" v-model="$v.emailValue.$model" placeholder="Agregar correo">
                    <label for="">Tipo de usuario a registrar</label>
                    <select name="" id="" v-model="$v.userType.$model">
                        <option v-for="(item, index) in usersTypes" :key="index" :value="item.id">{{item.name}}</option>
                    </select>
                    <div v-if="$v.userType.$error" class="error">El tipo de usuario es un campo obligatorio</div>
                    <button class="register-button" @click="saveData()">Registrar</button>
                </center>
            </div>
        </div>
    </div>
</template>

<script>
import {required, email, numeric} from 'vuelidate/lib/validators'
import API from '@/api'

export default {
    name: 'AgregarModelo',
    methods: {
        saveData() {
            if (this.$v.nameValue.$model === null) {
                this.$v.nameValue.$error = true
                return
            }
            if (this.$v.lastNameValue.$model === null) {
                this.$v.lastNameValue.$error = true
                return
            }
            if (this.$v.typeDocumentValue.$model === null) {
                this.$v.typeDocumentValue.$error = true
                return
            }
            if (this.$v.documentValue.$model === null) {
                this.$v.documentValue.$error = true
                return
            }
            if (this.$v.dayOfBirdthValue.$model === null) {
                this.$v.dayOfBirdthValue.$error = true
                return
            }
            if (this.$v.countryValue.$model === null) {
                this.$v.countryValue.$error = true
                return
            }
            if (this.$v.turnoValue.$model === null) {
                this.$v.turnoValue.$error = true
                return
            }
            if (this.$v.phoneValue.$model === null) {
                this.$v.phoneValue.$error = true
                return
            }
            if (this.$v.userType.$model === null) {
                this.$v.userType.$error = true
                return
            }
            if (this.$v.sedeValue.$model === null) {
                this.$v.phoneValue.$error = true
                return
            }
            var info = {
                phone: this.$v.phoneValue.$model,
                stagename: this.$v.nameValue.$model,
                lastname: this.$v.lastNameValue.$model,
                document_type: this.$v.typeDocumentValue.$model,
                document: this.$v.documentValue.$model,
                country: this.$v.countryValue.$model,
                date_of_birth: this.$v.dayOfBirdthValue.$model,
                turno: this.$v.turnoValue.$model,
                sede: this.$v.sedeValue.$model,
                email: this.$v.emailValue.$model,
                type: this.$v.userType.$model
            }
            API.profileAdminRegister(info)
                .then((info) => {
                    this.$router.push('/personal-administrativo')
                })
                .catch(() => {
                    console.log('no se guardo la informacion de las modelos')
                })
        },
        getCountriesList: function() {
            this.$http.get('https://restcountries.com/v3.1/all').then(function(response) {
                var contries = []
                response.body.forEach(country => {
                    if (country.name.common === 'Tanzania') {
                        return
                    }
                    contries.push(country.name.common)
                })
                this.countries = contries.sort()
            })
        },
        getUsersTypes: function() {
            API.getUsersTypes()
                .then((res) => {
                    this.userType = res[0].id
                    this.usersTypes = res
                })
        },
        getSedesList() {
            API.getSedesList()
                .then((res) => {
                    this.sedes = res
                })
        }
    },
    mounted() {
        this.getCountriesList()
        this.getUsersTypes()
        this.getSedesList()
    },
    data() {
        return {
            countries: [],
            usersTypes: [],
            nameValue: null,
            lastNameValue: null,
            typeDocumentValue: 'cc',
            documentValue: null,
            dayOfBirdthValue: null,
            countryValue: 'Colombia',
            turnoValue: 'm',
            phoneValue: null,
            emailValue: null,
            userType: null,
            sedes: [],
            sedeValue: null
        }
    },
    validations: {
        userType: {
            required
        },
        nameValue: {
            required
        },
        lastNameValue: {
            required
        },
        typeDocumentValue: {
            required
        },
        documentValue: {
            required,
            numeric
        },
        dayOfBirdthValue: {
            required
        },
        countryValue: {
            required
        },
        turnoValue: {
            required
        },
        phoneValue: {
            required
        },
        emailValue: {
            required,
            email
        },
        sedeValue: {
            required
        }
    }
}
</script>

<style scoped>
    .add-model {
        background-color: #cdcdcd;
        min-height: 100vh;
        padding: 50px;
        color: #000;
    }
    .info {
        padding: 50px;
        width: 100%;
        display: flex;
    }
    .info > .column {
        padding: 30px;
        width: 50%;
        border-style: solid;
        border-color: #fff;
    }
    .column > center {
        padding: 15px;
        display: grid;
    }
    .column > center > label, .info-wrapper > label, .info-wrapper > div > label {
        font-weight: bold;
        margin: 12px;
    }
    .column > center > input, select, .info-wrapper > input, .info-wrapper > div > input {
        min-width: 350px;
        height: 35px;
        text-align: center;
        border-style: ridge;
        border-radius: 15px;
    }
    .column > center > button, .info-wrapper > button, .info-wrapper > div > .platform-button {
        margin: auto;
        margin-top: 35px;
        margin-bottom: 0px;
        background-color: #e0b059;
        color: #fff;
        width: 150px;
        height: 60px;
        border-radius: 30px;
    }
    .info-wrapper > div > .platform-button {
        margin-top: 20px;
        width: 200px;
        height: 40px;
        margin-left: 10px;
    }
    /deep/ .column > center > .vue-tel-input {
        background-color: #fff;
        border-radius: 15px;
        border-style: ridge;
    }
    /deep/ .column > center > .vue-tel-input > input {
        height: 40px;
        text-align: center;
        border-radius: 15px;
        margin-left: -57px;
    }
    .column > center > .register-button {
        height: 40px;
        width: 250px;
    }
    /deep/ .check-number-modal-header {
        text-align: center;
        padding: 0;
        padding-top: 10px;
        display: block;
    }
    /deep/ .check-number-modal-header > button {
        position: absolute;
        right: 10px;
        top: 10px;
    }
    .info-wrapper > div {
        display: flex;
    }
    .info-wrapper > div > .img-container {
        border-radius: 50%;
        -webkit-box-shadow: 0px -3px 28px 11px rgba(0,0,0,0.15);
        -moz-box-shadow: 0px -3px 28px 11px rgba(0,0,0,0.15);
        box-shadow: 0px -3px 28px 11px rgba(0,0,0,0.15);
    }
    .fa-trash {
        padding: 20px;
    }
    .fa-trash:hover {
        color:red
    }
    .info-wrapper > div > img {
        padding: 25px;
        height: 70px;
    }
    .info-wrapper > div > label {
        padding: 10px;
    }
    .info-wrapper > div > div {
        width: 100px;
        height: auto;
        margin: 5px;
    }
    .info-wrapper > div > div > img {
        width: 100px;
        padding: 10px;
    }
    .error {
        color: red;
        font-size: 12px;
    }
    .info-wrapper > .form {
        display: grid;
    }
</style>



// WEBPACK FOOTER //
// src/components/AdminsProfiles/AddAdminProfile.vue